/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import '../../crp_meta_ui/elements/error-component.js';
import "../../crp_meta_ui/elements/dropdown-landing.js";
import "./fin-page-footer.js";
const template = html`
<custom-style>
  <style include="login-styles">
    :dir(ltr) .message {
      margin-left: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-right: 4%; */
    }
	
	:dir(rtl) .message {
      margin-right: 5%;
     /* margin-top: -4%; */
      /* Removing margin to make the line span till the end. Part of UI review done for add funds flow */
      /* margin-left: 4%; */
    }
	
	.stealthy{
				display: none;
                left: 0;
                margin: 0;
                max-height: 1px;
                max-width: 1px;
                opacity: 0;
                outline: none;
                overflow: hidden;
                pointer-events: none;
                position: absolute;
                top: 0;
                z-index: -1;
            }
    .align-ev-input {
      text-align:left;
      margin-left:16px;
      margin-right:16px;
    }
		:dir(rtl) .stealthy{
			display: none;
			right: 0;
			left: auto;
			margin: 0;
			max-height: 1px;
			max-width: 1px;
			opacity: 0;
			outline: none;
			overflow: hidden;
			pointer-events: none;
			position: absolute;
			top: 0;
			z-index: -1;
        }
    	@media all and (-ms-high-contrast:none)
      	{
		oe-input {
          		--paper-input-container-label: {
              			top: -4px;
            		}
          	}
      	}
          app-dialog{
              --iron-input: {
                display:none !important;
              }
          }

          .center-image{
			  margin-left: 30%;
		  }
          .imgstyle{
              height:50px;
              width:100px;
          }
          .descriptionStyle{
            border: 2px solid teal;
            padding: 2px 8px 2px 7px;
            border-radius: 20px;
          }
          .iron-icon-terms{
            height: 30px;
            width: 30px;
          }
          .font-32{
            font-size: 32px;
          }
          .font-22{
            font-size: 22px;
          }
          .widthMixin{
            --dropdownwidth : 115%;
            --dropdownheight : 40px;               
         }  
         .attemptsStyle{
            font-weight: 400;
            font-size: 18px;
            line-height: 30px; 
            display: flex;
            align-items: center;
            text-align: center;
            letter-spacing: 0.0025em;
         }
         .blurClass{
            filter: blur(5px);
          }
          .mb-margin{
            margin:30px;
        }
        .paddingClass{
            padding-right: 10px;
        }
        /* MB style */
        @media (max-width: 479px){
            .mb-margin{
                margin:0px;
            }
        }
        .otp-expiry-countdown{
            color: var(--critical-label-color);
        }
  </style>
  </custom-style>
  <oe-ajax id="crontoValidate" method="post" content-type="application/json" on-response="handleResponse" on-error="handleCrontoError"></oe-ajax>
  <div style=""><error-component></error-component></div>
  <div id="main-container" class="light-background margin-b-zero">
        <div class="mdl-grid " style="border-bottom:2px solid #dbdfe8;padding: 20px 0px;" >
            <div class="mdl-cell mdl-cell--2-col">
                <div class="content-align-vertical-center mb-margin">
                    <iron-icon class="iron-icon-style-s cursor-pointer" icon="icons:arrow-back" on-tap="goToBackpage" style="color:#04859C;"></iron-icon> 
                    <oe-i18n-msg class="cursor-pointer font-16"  msgid="b_Back" style="color:#04859C" on-tap="goToBackpage"></oe-i18n-msg>
                </div>
            </div>
            <div class="layout mdl-cell mdl-cell--8-col vertical" style="margin-top:15px;">
                <div class="content-align-center font-32 font-weight-bold mdl-cell mdl-cell--12-col">
                    <oe-i18n-msg msgid="l_scanSecureImageNote"></oe-i18n-msg>
                </div>
                <div class="font-22 secondary-color content-align-center mdl-cell mdl-cell--12-col">
                    <oe-i18n-msg msgid="l_openNBBappOfflineCodeNote"></oe-i18n-msg>
                </div>
            </div>
            <div class="mdl-cell mdl-cell--2-col">
            </div>
        </div>
        <div class="content-align-center mdl-cell mdl-cell--12-col">        
            <div style="padding: 1%;" >
                <div id="imageClass" class="content-align-center" style="padding-bottom: 25px;">
                    <img src="{{crontoData}}" alt="Green dot" />         
                </div>
                <div class="content-align-center layout vertical">
                    <div class="" hidden$={{timeOutTxtFlag}}>
                        <oe-i18n-msg class="font-24 font-weight-700" msgid="l_TxnImgExpiredNote"></oe-i18n-msg>
                    </div>
                    <div class="attemptsStyle content-align-center horizontal layout margin-b-zero mdl-cell mdl-cell--12-col secondary-color" hidden$={{!timeOutTxtFlag}}>
                        <oe-i18n-msg class="font-weight-700 paddingClass" msgid="l_pleaseNote" ></oe-i18n-msg>
                        <oe-i18n-msg msgid="l_scanImageMsg"></oe-i18n-msg>    
                    </div>
                    <div class="attemptsStyle content-align-center margin-t-zero mdl-cell mdl-cell--12-col secondary-color" hidden$={{!timeOutTxtFlag}}> 
                        <oe-i18n-msg msgid="l_txnAuthenticationNote5"></oe-i18n-msg>
                    </div>
                    <div class="font-18 secondary-color content-align-center mdl-cell mdl-cell--12-col">
                        <oe-i18n-msg msgid="l_havingTroubleSigningIn"></oe-i18n-msg>
                    </div>
                    <div>
                    <dropdown-landing class = "widthMixin" borderright = {{borderright}} icon-color = {{iconColor}} fontcolor = {{fontcolor}} dropdown-bck-color = {{dropdownBckColor}} dropdown-bord-color = {{dropdownBordColor}}
                        new-height = {{newHeight}} place-holder-name = {{placeHolderName}} dropdownlist = {{dropdownlist}} 
                        selected-value = {{selectedValue}}>
                    </dropdown-landing>
                </div>
            </div>
            <template is = "dom-if" if = "{{showTimer}}">
                <div class="mdl-cell--12-col horizontal layout content-align-center">
                    <div class="content-align-center">
                        <div class="content-align-horizontal-end font-18 mdl-cell--12-col" style="padding-left: 25px;padding-top:20px;">
                            <oe-i18n-msg msgid="h_LoginSecurityImageExpireMsg"></oe-i18n-msg>
                            <span class="content-align-horizontal-end otp-expiry-countdown" id="time">&nbsp;&nbsp;{{countDownTime}}</span>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
    <div class="">
        <div class=" light-background" style="height: 35%;padding-left: 3%;">
            <div class="content-align-center font-size-l mdl-cell mdl-cell--12-col teal-color" style="padding-top: 2%;" on-tap="resetMpinFunction">
                <oe-i18n-msg msgid="l_resetMpinAndAdvancedSecurityOptions" class="cursor-pointer" style="text-decoration: underline;"></oe-i18n-msg>
            </div>
        </div>
        <div class="mdl-cell--12-col mdl-grid light-background"></div>
        <fin-page-footer/>
    </div>
  </div> 
  `;
Polymer({
    is: 'fin-auth-secureimage',
    _template: template,
    properties: {
        selectedFlag: {
            type: Boolean,
            notify: true,
            value: false
        },
        selectedModePage: {
            type: Number,
            notify: true,
            observer: '_timedApiCall'
        },
        selectedPage: {
            type: Number,
            notify: true,
            observer: '_timedApiCall'
        },
        authModeResponse: {
            type: Object,
            notify: true,
            observer: '_setCrontoData'
        },
        crontoData: {
            type: String,
            value: '',
            notify: true,
        },
        dataBody: {
            type: Object,
            notify: true
        },
        qrResponse: {
            type: Object,
            notify: true,
            observer: '_checkSuccess'
        },
        selectedFlag: {
            type: Boolean,
            notify: true
        },
        AttemptNum: {
            type: Number,
            notify: true,
            value: 1
        },
        AttemptLimitNum: {
            type: Number,
            notify: true,
            value: 5
        },
        dropdownlist: {
            type: Array,
            notify: true
        },
        placeHolderName: {
            type: String,
            notify: true
        },
        newHeight: {
            type: String,
            notify: true
        },
        dropdownBckColor: {
            type: String,
            notify: true
        },
        dropdownBordColor: {
            type: String,
            notify: true
        },
        fontcolor: {
            type: String,
            notify: true
        },
        borderright: {
            type: String,
            notify: true
        },
        iconColor: {
            type: String,
            notify: true
        },
        authModeBody: {
            type: Object,
            notify: true
        },
        authSuccess: {
            type: Boolean,
            notify: true,
            value: false
        },
        selectedValue: {
            type: String,
            notify: true,
            observer: "_resetTime"
        },
        authModeList: {
            type: Array,
            notify: true,
            observer: ''
        },
        tempList: {
            type: Array,
            notify: true
        },
        resetMpin: {
            type: Boolean,
            notify: true
        },
        timeInterval: {
            type: Number,
            notify: true
        },
        timeIntervalLimit: {
            type: Number,
            notify: true
        },
        timeOutTxtFlag: {
            type: Boolean,
            value: true,
            notify: true
        },
        callStatusApi: {
            type: Boolean,
            value: true,
            notify: true
        },
        showTimer: {
            type: Boolean,
            value: false
        }
    },
    ready: function () {
    },
    attached: function () {
        this.placeHolderName = "Choose another method"
        this.newHeight = "40px";
        this.dropdownBckColor = "white !important";
        this.dropdownBordColor = "#003D4C";
        this.fontcolor = "#003D4C";
        this.borderright = "1px";
        this.iconColor = "#003D4C";
        this.proceedFlag = true;
    },
    goToBackpage() {
        clearInterval(this.interval);
        clearTimeout(this.timeOut);
        this.authSuccess = false;
        this.selectedPage = 0;
        this.selectedValue = "";
    },
    _setCrontoData() {
        if (this.authModeResponse.crontoImageData != undefined) {
            this.crontoData = "data:image/png;base64," + this.authModeResponse.crontoImageData;
            this.timeOutTxtFlag = true;
            this.shadowRoot.querySelector('#imageClass').classList.remove('blurClass');
        }
    },
    _timedApiCall() {
        if (this.selectedModePage == 0 && this.selectedPage == 2) {
            this.qrResponse = undefined;
            this.setDropdownList();
            this.callStatusApi = true;
            if (config.SpeedBoat.App.authInterval) {
                this.timeInterval = config.SpeedBoat.App.authInterval.intervalSecs;
                this.timeIntervalLimit = config.SpeedBoat.App.authInterval.intervalSecsLimit;
            }
            var self = this;
            this.deviceRegistrationTimer();
            this.showTimer = true;
            this.interval = setInterval(function () {
                if (self.callStatusApi) {
                    self.apicall();
                }
            }.bind(this), 1000 * this.timeInterval);
            this.timeOut = setTimeout(function () {
                self.stopApicall()
                self.showTimer = false;
            }.bind(this), 1000 * this.timeIntervalLimit);
        }
    },
    handleResponse: function (e) {
        this.qrResponse = e.detail.response;
        if (!_.isEmpty(this.qrResponse) && this.qrResponse.status && this.qrResponse.status.cmCode == "PEN") {
            this.callStatusApi = true;
        }
    },
    apicall() {
        var Data = JSON.parse(this.authModeBody);
        Data.ochTransactionId = "";
        Data.ochTransactionId = this.authModeResponse.ochTransactionId;
        //Data.ochTransactionId='OCHTRANID1643615133522';
        this.$.crontoValidate.body = JSON.stringify(Data);
        this.$.crontoValidate.url = "/auth/customloginpushandcorntoauthetcate";
        if (_.isEmpty(this.qrResponse) || !_.isEmpty(this.qrResponse) && !(this.qrResponse.status.cmCode == "SUC" || this.qrResponse.status.cmCode == "FAL")) {
            this.$.crontoValidate.generateRequest();
            this.callStatusApi = false;
        }
    },
    stopApicall() {
        clearInterval(this.interval);
        this.timeOutTxtFlag = false;
        this.shadowRoot.querySelector('#imageClass').classList.add('blurClass');
        if (this.authSuccess != true) {
            this.fire("oe-show-error", getLabel("l_loginTimeoutMsgNote"));
        }
    },
    _checkSuccess() {
        if (this.qrResponse != undefined) {
            if (this.qrResponse.status.cmCode == "SUC") {
                this.authSuccess = true;
                clearInterval(this.interval);
                clearTimeout(this.timeOut);
            }
            else if (this.qrResponse.status.cmCode == "FAL") {
                clearInterval(this.interval);
                clearTimeout(this.timeOut);
                this.fire("oe-show-error", getLabel("l_loginFailedInfo")); //'try again!!!!!!'); 
            }
        }
    },
    successCall() {
        this.authSuccess = true;
        clearInterval(this.interval);
    },
    setDropdownList() {
        this.dropdownlist = [];
        if (this.selectedModePage == 0) {
            if (this.authModeResponse != "" && this.authModeResponse != undefined) {
                for (let i = 0; i < this.authModeList.length; i++) {
                    if (this.authModeList[i].cmCode != this.authModeResponse.primaryAuthenticationMode.cmCode) {
                        this.dropdownlist.push({ label: this.authModeList[i].codeDescription, id: this.authModeList[i].cmCode });

                    }
                }
            }
        }
    },
    resetMpinFunction() {
        clearInterval(this.interval);
        clearTimeout(this.timeOut);
        this.resetMpin = true;
        this.selectedPage = 0;
    },
    _resetTime() {
        if (this.selectedModePage == 0 && this.selectedValue != "") {
            clearInterval(this.interval);
            clearTimeout(this.timeOut);
        }
    },
    handleCrontoError(event) {
        clearInterval(this.interval);
        clearTimeout(this.timeOut);
        if (_.isEmpty(this.qrResponse) || !_.isEmpty(this.qrResponse) && !(this.qrResponse.status.cmCode == "SUC" || this.qrResponse.status.cmCode == "FAL")) {
            //showAjaxError(event);
            this.callStatusApi = true;
        }
    },
    deviceRegistrationTimer() {
        this.countDownTime = undefined;
        this.otpExpTime = config.SpeedBoat.App.authInterval.intervalSecsLimit;
        this.startTimer(this.otpExpTime);
        this.enableOtpCounter = true;
        this.resendOtpDisabled = true;
        // setTimeout(function () {
        //     self.resendOtpDisabled = false
        // }, 1000 * this.otpExpTime)
    },
    startTimer: function (duration) {
        var self = this;
        var timer = duration;
        if (typeof this.worker1 != "undefined") {
            this.worker1.terminate();
        }
        var blobURL = URL.createObjectURL(new Blob([`
          var timer = `+ timer + `,
            minutes,
             seconds;
             var myVar = null;
             myVar = setInterval(function () {
             minutes = parseInt(timer / 60, 10);
             seconds = parseInt(timer % 60, 10);

             minutes = minutes < 10 ? "0" + minutes : minutes;
             seconds = seconds < 10 ? "0" + seconds : seconds;
             countDownTime = minutes + "m " + seconds + "s";
             postMessage( minutes + "m " + seconds + "s");
             --timer;    
             }, 1000);`], {
            type: "application/javascript"
        }));
        this.worker1 = new Worker(blobURL);

        this.worker1.onmessage = function (event) {
            if (--timer >= 0) {
                self.countDownTime = event.data;
            } else {
                self.enableOtpCounter = false;
                self.resendOtpDisabled = false;
                self.worker1.terminate();
            }
        };
    }
});